import { render } from "./Features.vue?vue&type=template&id=9004f706&ts=true"
import script from "./Features.vue?vue&type=script&lang=ts"
export * from "./Features.vue?vue&type=script&lang=ts"

import "./Features.vue?vue&type=style&index=0&id=9004f706&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__